import { CommonModule } from '@angular/common'
import { Component, inject, signal } from '@angular/core'
import { Router, RouterModule } from '@angular/router'
import { SignupInput } from '@mattrika/benefit-model'
import { NgIconComponent, provideIcons } from '@ng-icons/core'
import {
    lucideArrowLeft,
    lucideSparkles,
    lucideShieldCheck,
    lucideTag,
    lucideAlertCircle,
    lucideCheckCircle2,
} from '@ng-icons/lucide'
import { AuthStateService } from '../../auth/auth-state.service'
import { RegisterFormService } from '../../services/register-form.service'
import { RegisterUserFormComponent } from '../register-user-form/register-user-form.component'

@Component({
    selector: 'lib-page-register',
    imports: [
        CommonModule,
        RouterModule,
        NgIconComponent,
        RegisterUserFormComponent,
    ],
    templateUrl: './page-register.component.html',
    styleUrls: ['./page-register.component.css'],
    providers: [
        RegisterFormService,
        provideIcons({
            lucideArrowLeft,
            lucideSparkles,
            lucideShieldCheck,
            lucideTag,
            lucideAlertCircle,
            lucideCheckCircle2,
        }),
    ],
})
export class PageRegisterComponent {
    public readonly registerFormService = inject(RegisterFormService)
    private readonly authStateService = inject(AuthStateService)
    private readonly router = inject(Router)

    readonly isSubmitting = signal(false)
    readonly errorMessage = signal('')

    onRegisterSubmit(payload: SignupInput) {
        this.isSubmitting.set(true)
        this.errorMessage.set('')

        this.authStateService.register(payload).subscribe({
            next: (response) => {
                this.isSubmitting.set(false)

                if (response.success) {
                    this.router.navigate(['/login'])
                }
            },
            error: ({ error }) => {
                this.isSubmitting.set(false)
                this.errorMessage.set(
                    error?.message ||
                        'Registration failed. Please check your information and try again.',
                )
            },
        })
    }
}
